'use client';

import * as React from 'react';
import { NextAppDirEmotionCacheProvider } from './EmotionCache';
import { ColorModeProvider } from './ColorModeProvider';

// Client boundary for MUI / Emotion. The ColorModeProvider owns the active
// MUI theme; it rebuilds via useMemo whenever the user flips the toggle.
export default function ThemeRegistry({ children }: { children: React.ReactNode }) {
  return (
    <NextAppDirEmotionCacheProvider options={{ key: 'mui' }}>
      <ColorModeProvider>
        {children}
      </ColorModeProvider>
    </NextAppDirEmotionCacheProvider>
  );
}
